import React from 'react';

import { Row } from '../atoms/row';
import { LinkComponent } from '../atoms/link-component';

import { Inspect as InspectComp } from '../templates/inspect';

export const Inspect = () => {
  return (
    <>
      <h1>Inspect</h1>

      <Row gap={1}>
        <LinkComponent to="/inspect">Home</LinkComponent>
        <LinkComponent to="/inspect/inverter">Inverter</LinkComponent>
        <LinkComponent to="/inspect/wallbox">Wallbox</LinkComponent>
        <LinkComponent to="/inspect/heat-pump">Heat pump</LinkComponent>
        <LinkComponent to="/inspect/mqtt">MQTT</LinkComponent>
        <LinkComponent to="/inspect/plugs">Plugs</LinkComponent>
        <LinkComponent to="/inspect/spot">Spot</LinkComponent>
        <LinkComponent to="/inspect/plc">PLC</LinkComponent>
      </Row>

      <InspectComp />
    </>
  );
};

export default Inspect;
